import { gql } from '@apollo/client';

export const FourPartTestFragment = gql`
  fragment FourPartTest on FourPartTest {
    id
    industries
    tools
    researchActivities
  }
`;
